import React from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { useTranslation } from "react-i18next";
import { checkCardNumber } from "../../utils/validations";

import { formatCreditCardNumber, getBankPaymentIcon } from "../../utils/formats";

function CreditCardNumber({ form, setForm, setFocusOnInput = () => {}, tradeInfo }) {
  const { t } = useTranslation();
  return (
    <>
      <TextField
        onFocus={() => {
          setFocusOnInput(true);
        }}
        onClick={(event) => {
          event.stopPropagation();
        }}
        inputProps={{ autocomplete: "new-password" }}
        size="small"
        error={!form.cardNumber.valid}
        helperText={!form.cardNumber.valid && t("invalid_card_no")}
        className="homeMobile__filling__content__input"
        label={t("card_no")}
        variant="outlined"
        value={form.cardNumber.value}
        onChange={(event) => {
          let value = formatCreditCardNumber(event.target.value);
          setForm((prev) => {
            return {
              ...prev,
              cardNumber: { ...prev.cardNumber, value: value },
            };
          });
        }}
        onBlur={() => {
          checkCardNumber({ form: form, setForm: setForm });
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <img
                src={getBankPaymentIcon(form.cardNumber.value)}
                alt=""
                style={{
                  height: "20px",
                }}
              />
            </InputAdornment>
          ),
        }}
      />
    </>
  );
}

export default CreditCardNumber;
